import React, { useState, useEffect, useMemo } from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import crossIcon from "../../assets/images/cross.svg";
import Text from "components/Text";
import Input from "components/Input";
import { updateSessionTitle } from "repositories/ai-assistant-repository";
import { handleError, handleSuccess } from "utils";

function RenameChatModal({
  isModalOpen,
  closeModal,
  t,
  listItem,
  setIsProcessing,
  onRename,
}) {
  const [newTitle, setNewTitle] = useState(listItem?.title);

  useEffect(() => {
    setNewTitle(listItem?.title);
  }, [listItem]);

  const validationError = useMemo(() => {
    if (!newTitle?.trim()) {
      return t("aiAssistant.threadValidationMsg");
    }
    return "";
  }, [newTitle, t]);

  const editTitle = async () => {
    if (validationError) return;
    try {
      setIsProcessing(true);
      const res = await updateSessionTitle(listItem?.id, newTitle);
      handleSuccess(res.message);
      onRename?.(listItem?.id, newTitle);
      closeModal();
    } catch (error) {
      handleError(error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-dialog-centered delete-modal modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="20px" weight="500" color="#111b45">
          <span className="modal-title-25">{`${t(
            "aiAssistant.renameChat"
          )}?`}</span>
        </Text>
        <Input
          Placeholder={t("aiAssistant.renameChat")}
          Title="New Name"
          Value={newTitle}
          HandleChange={(e) => setNewTitle(e.target.value)}
          Error={validationError}
          MaxLength="120"
        />
        <div className="btn-box d-md-flex gap-sm padding_top_10">
          <button
            className="button button-round button-shadow mb-3 w-sm-100  mr-md-2"
            title={t("rename")}
            onClick={editTitle}
          >
            {t("rename")}
          </button>
          <button
            className="mb-md-3 button button-round button-border btn-mobile-link button-dark "
            title={t("cancel")}
            onClick={closeModal}
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(RenameChatModal);
